import { Avatar, Box, Card, CardContent, CardHeader, CircularProgress, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import { Poll } from "@material-ui/icons";
import moment from "moment";
import { Bar, BarChart, Tooltip, XAxis } from 'recharts';
import _ from "underscore";
import { useFirestoreQuery } from "../../../firebase/hooks";
import { firestore } from "../../../helpers/firebaseHelper";
import { IsNullOrEmpty, paginate } from "../../../helpers/utility";
import { Alert, Pagination } from "@material-ui/lab";
import { useState, useEffect } from "react";
const pageSize = 10;

export default function LeadSurvey(props) {
    const { livestream, searchText, filter } = props;
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const livestreamsRef = firestore.collection('livestreams');
    const stream = useFirestoreQuery(
        livestreamsRef.where("id", "==", livestream)
    );

    useEffect(() => {
        setLoading(!loading)
    }, [stream])


    let data = [];

    let polls = stream && stream[0] && stream[0].pollings && stream[0].pollings;
    if (polls) {
        polls = _.groupBy(polls, "rating");

        Object.keys(polls).forEach((x) => {
            data.push({
                name: x,
                uv: polls[x].length
            })
        })
    }

    let filteredList = stream && stream[0] && stream[0].pollings;
    if (!filteredList) {
        filteredList = [];
    }

    if (!IsNullOrEmpty(searchText)) {
        filteredList = filteredList.filter((x) =>
            x.userName.toLowerCase().indexOf(searchText.toLowerCase()) > -1);
    }

    if (!IsNullOrEmpty(filter)) {
        let startTime = moment().startOf('day');
        let endTime = moment().endOf('day');
        switch (filter) {
            case "Today":
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
            case "Week":
                startTime = moment().startOf("weeks");
                endTime = moment().endOf('weeks');
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
            case "Month":
                startTime = moment().startOf('month');
                endTime = moment().endOf('month');
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
            case "Year":
                startTime = moment().startOf('year');
                endTime = moment().endOf('year');
                filteredList = filteredList.filter((x) => {
                    return moment.unix(x.createdAt).isBetween(startTime, endTime)
                })
                break;
        }
    }

    let totalPages = Math.ceil(filteredList.length / pageSize);
    filteredList = paginate(filteredList, pageSize, page);

    return <Grid container className="mt-4" spacing={2}>
        <Grid xs={12} sm={12} md={8} lg={8}>
            <Grid container className="mt-4">
                <Grid xs={12} sm={12}>
                    <Grid container>
                        <Grid item md={4} lg={4} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">
                            Date
                        </Grid>
                        <Grid item md={4} lg={4} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60  p-2">
                            Full Name
                        </Grid>
                        <Grid item md={4} lg={4} xs={12} sm={12} className="bg-whitesmoke1 text-sm font-medium text-black-60 p-2">
                            Vote
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs={12} sm={12}>
                    {
                        filteredList.map((st) => {
                            return <>
                                <Grid container>
                                    <Grid item md={4} lg={4} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex flex-align-center">
                                        {moment.unix(st.createdAt).format("ll")}<br />
                                        {moment.unix(st.createdAt).format("hh:mm:ss a")}
                                    </Grid>
                                    <Grid item md={4} lg={4} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-0">
                                        <List disablePadding>
                                            <ListItem disableGutters className="p-0">
                                                <ListItemAvatar>
                                                    <Avatar style={{ background: "transparent", border: "2px solid #E38301", color: "#E38301" }}>{st.userName && st.userName[0]}</Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={st.userName} secondary={"@" + st.userName} />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid item md={4} lg={4} xs={12} sm={12} className="bg-white text-sm font-medium text-black-60 p-2 flex  flex-align-center">
                                        {st.rating}
                                    </Grid>
                                </Grid>
                                <Divider />
                            </>
                        })
                    }
                    {
                        !loading && filteredList.length === 0 ?
                            IsNullOrEmpty(searchText) ?
                                <Alert severity="error" className="mt-4">No Poll leads available now</Alert> :
                                <Alert severity="error" className="mt-4">No Poll leads available for the selected criteria</Alert> :
                            ""
                    }
                    {
                        loading && <Box display={"flex"} alignItems={"center"} justifyContent={"center"} className="m-4">
                            <CircularProgress />
                        </Box>
                    }
                </Grid>
                <Grid xs={12} sm={12}>
                    {
                        filteredList.length > 0 &&

                        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} className="my-2">
                            <Pagination
                                shape="rounded"
                                variant="outlined"
                                count={totalPages}
                                page={page}
                                color="primary"
                                onChange={(e, pg) => {
                                    setPage(pg)
                                }} />
                        </Box>
                    }
                </Grid>
            </Grid>
        </Grid>
        <Grid xs={12} sm={12} md={4} lg={4}>
            <Card variant="outlined" className="m-4">
                <CardHeader
                    avatar={<Avatar style={{ background: "transparent", border: "2px solid #E38301", color: "#E38301" }}>
                        <Poll color="secondary" />
                    </Avatar>}
                    title="Polling"
                    subheader="Result"
                />
                <CardContent>
                    <div>
                        <span>Total Votes</span><br />
                        <span>{stream && stream[0] && stream[0].pollings && stream[0].pollings.length}</span>
                    </div>
                    <Divider />
                    <div style={{ minHeight: 250, minWidth: 200 }}>
                        <BarChart width={250} height={250} data={data}>
                            <Bar dataKey="uv" fill="#8884d8" />
                            <XAxis dataKey="name" />
                            <Tooltip />
                        </BarChart>
                    </div>
                </CardContent>
            </Card>
        </Grid>
    </Grid>
}